// src/lib/echapper-html.js — faille N1 (revue du 29/10, lot L5).
//
// Échappe une valeur avant de l'écrire dans un document HTML (facture
// mensuelle, rapport mensuel). Même conversion qu'une interpolation `${v}`
// (`String(v)`, donc `undefined` reste « undefined ») : une valeur sans
// caractère spécial sort à l'identique, le document d'une pièce normale ne
// change pas d'un octet. Avec un caractère spécial (« O'Brien », « & »), les
// octets changent mais le texte affiché reste le même.
export function echapperHtml(v) {
  return String(v)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}
